import * as React from "react";
import "./index.scss";
import DOWN_ICON from "../../assets/down.svg";
import ActionSheet from "../actionsheet";
import toast from "lib/toast";
import {
  initTron,
  getResourceDistributionInTrx,
  getDelegatedResource,
  tronWeb,
} from "lib/tron";
import { formatSmartBalance as fb } from "lib/format";
import { pubsub } from "lib/event";
import dayjs from "dayjs";
import t from "locales";

interface Props {
  account: {
    address: string;
    accountInfo: any;
    resource: any;
  };
}

interface State {
  resourceType: "BANDWIDTH" | "ENERGY";
  receiverType: number;
  resourceModalVisible: boolean;
  receiverModalVisible: boolean;
  to: string;
  amount: string;
  earnEnergy: number;
  earnBandwidth: number;
  delegateBp: { amount: number; expire_time: number };
  delegateEnergy: { amount: number; expire_time: number };
}

export class ResourceManage extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      resourceType: this.getUrlResourceType(),
      receiverType: 0,
      resourceModalVisible: false,
      receiverModalVisible: false,
      to: "",
      amount: "",
      earnEnergy: 0,
      earnBandwidth: 0,
      delegateBp: { amount: 0, expire_time: 0 },
      delegateEnergy: { amount: 0, expire_time: 0 },
    };
  }

  getUrlResourceType(): "BANDWIDTH" | "ENERGY" {
    const qs = window["location"].search.substring(1);
    const searchParams = new URLSearchParams(qs);
    if (searchParams.get("type")) {
      //@ts-ignore
      return searchParams.get("type").toUpperCase();
    } else {
      return "BANDWIDTH";
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      to: this.state.to,
    });
  }

  getBpUnfreezeTime = () => {
    const { account } = this.props;
    const info = account && account.accountInfo;
    if (info && Array.isArray(info.frozen)) {
      return info.frozen[0] && info.frozen[0].expire_time;
    }
  };

  getEnergyUnfreezeTime = () => {
    const { account } = this.props;
    return account?.accountInfo?.account_resource?.frozen_balance_for_energy?.expire_time
  };

  render() {
    const { account } = this.props;
    const {
      resourceType,
      resourceModalVisible,
      receiverModalVisible,
      to,
      receiverType,
      delegateBp,
      delegateEnergy,
    } = this.state;
    const isBandwidth = resourceType === "BANDWIDTH";
    const isEnergy = !isBandwidth;
    const isSelf = receiverType === 0;

    const selfEnergyUnfreezeTime = this.getEnergyUnfreezeTime();
    const selfBpUnfreezeTime = this.getBpUnfreezeTime();

    const { self_bp, self_energy } = getResourceDistributionInTrx(account);
    const unfreezeAbleBp = isSelf ? self_bp : delegateBp.amount;
    const unfreezeAbleEnergy = isSelf ? self_energy : delegateEnergy.amount;
    const unfreezeBpTime = isSelf ? selfBpUnfreezeTime : delegateBp.expire_time;
    const unfreezeEnergyTime = isSelf
      ? selfEnergyUnfreezeTime
      : delegateEnergy.expire_time;

    const bpNotTime = !!unfreezeBpTime && Date.now() < unfreezeBpTime;
    const energyNotTime =
      !!unfreezeEnergyTime && Date.now() < unfreezeEnergyTime;

    const disabledUnfreeze =
      (isEnergy && (!unfreezeAbleEnergy || energyNotTime)) ||
      (isBandwidth && (!unfreezeAbleBp || bpNotTime));

    return (
      <div className="resource-manage">
        <h2 className="title">{t("unfreeze_v1_staked_trx")}</h2>

        <div className="form-card">
          <div
            className="input-item"
            onClick={() => this.setState({ resourceModalVisible: true })}
          >
            <span>{t("resource")}</span>
            <p>
              <span>{isBandwidth ? t("bandwidth") : t("energy")}</span>
              <img src={DOWN_ICON} alt="resource switch" />
            </p>
          </div>

          <div className="input-group">
            <div
              className="input-item"
              onClick={() => this.setState({ receiverModalVisible: true })}
            >
              <span>{t("receiver")}</span>
              <p>
                <span>{isSelf ? t("self") : t("others")}</span>
                <img src={DOWN_ICON} alt="resource switch" />
              </p>
            </div>
            {receiverType === 1 ? (
              <div className="input-item  input-wrap">
                <input
                  className="receiver"
                  placeholder={t("receiver_address")}
                  type="text"
                  onChange={this.setReceiver}
                  value={to}
                />
              </div>
            ) : (
              <div className="input-item">
                <p className="receiver">{account ? account.address : ""}</p>
              </div>
            )}
          </div>

          {((isBandwidth && bpNotTime) || (isEnergy && energyNotTime)) && (
            <div className="mark">
              {t(
                "wait_time_to_unfreeze",
                dayjs(isBandwidth ? unfreezeBpTime : unfreezeEnergyTime).format(
                  "YYYY/MM/DD HH:mm"
                )
              )}
            </div>
          )}
        </div>
        <div
          className={disabledUnfreeze ? "button disabled" : "button unfreeze"}
          onClick={disabledUnfreeze ? () => {} : this.submit}
        >
          <span>{t("unfreeze")}</span>
        </div>

        {resourceModalVisible && (
          <ActionSheet
            options={[
              { locale: t("bandwidth"), key: "BANDWIDTH" },
              { locale: t("energy"), key: "ENERGY" },
            ]}
            title={t("resource_type")}
            close={() => this.setState({ resourceModalVisible: false })}
            onSelect={this.setResourceType}
          />
        )}

        {receiverModalVisible && (
          <ActionSheet
            options={[
              { locale: t("self"), key: 0 },
              { locale: t("others"), key: 1 },
            ]}
            title={t("receiver")}
            close={() => this.setState({ receiverModalVisible: false })}
            onSelect={this.setReceiverType}
          />
        )}
      </div>
    );
  }

  setReceiver = (e) => {
    const { account } = this.props;
    const to = e.target.value;
    this.setState({ to: e.target.value }, async () => {
      if (tronWeb && tronWeb.isAddress(to)) {
        const resource = await getDelegatedResource(account.address, to);
        if (to === this.state.to) {
          this.setState({
            delegateBp: resource.bp,
            delegateEnergy: resource.energy,
          });
        }
      } else {
        this.setState({
          delegateBp: { amount: 0, expire_time: 0 },
          delegateEnergy: { amount: 0, expire_time: 0 },
        });
      }
    });
  };

  setResourceType = (option) => {
    this.setState({ resourceType: option });
  };

  setReceiverType = (receiverType) => {
    this.setState({ receiverType });
  };

  submit = () => {
    const { account } = this.props;
    const from = account.address;
    const { resourceType, to, receiverType } = this.state;
    const imToken = window["imToken"];
    const receiver = receiverType === 1 ? to : from;

    const handleError = (e) => {
      if (e?.errorCode !== 1001 && e?.code !== 4001) {
        if (e.message.includes("not time to unfreeze")) {
          const time =
            resourceType === "BANDWIDTH"
              ? this.getBpUnfreezeTime()
              : this.getEnergyUnfreezeTime();
          toast.error(dayjs(time).format("YYYY/MM/DD HH:mm"), {
            heading: t("not_time_to_unfreeze"),
          });
        } else {
          toast.error(e.message);
        }
      }
    };

    imToken
      .callPromisifyAPI("tron.buildUnfreezeBalanceTx", {
        resource: resourceType,
        ownerAddress: from,
        receiverAddress: receiver,
      })
      .then((tx) => {
        imToken
          .callPromisifyAPI("tron.sendTransaction", { tx, from })
          .then((txHash) => {
            let hideLoadingFn = toast.loading(txHash, {
              heading: t("packing"),
              hideAfter: 0,
            });
            this.checkReceipt(
              txHash,
              (txID) => {
                hideLoadingFn();
                toast.success(txID, { heading: t("unfreeze_success") });
                pubsub.emit("refreshAccountInfo");
                //@ts-ignore
                window["gtag"](
                  "event",
                  `unfreeze_${receiverType === 0 ? "self" : "other"}`,
                  {
                    event_category: resourceType.toLowerCase(),
                    event_label: "success",
                  }
                );
              },
              (errorMessage) => {
                hideLoadingFn();
                toast.error(errorMessage);
                window["gtag"](
                  "event",
                  `unfreeze_${receiverType === 0 ? "self" : "other"}`,
                  {
                    event_category: resourceType.toLowerCase(),
                    event_label: "fail",
                  }
                );
              }
            );
          })
          .catch(handleError);
      })
      .catch(handleError);
  };

  async checkReceipt(txHash, cb, failcb) {
    const [tronWeb] = await initTron();
    tronWeb.trx
      .getConfirmedTransaction(txHash)
      .then((res) => {
        if (res?.ret && res.ret[0]) {
          if (res.ret[0].contractRet === "SUCCESS") {
            cb(res.txID);
          } else {
            failcb(res.ret[0].contractRet);
          }
        } else {
          setTimeout(() => this.checkReceipt(txHash, cb, failcb), 2000);
        }
      })
      .catch(() => {
        setTimeout(() => this.checkReceipt(txHash, cb, failcb), 2000);
      });
  }
}

export default ResourceManage;
